import { render, staticRenderFns } from "./TheAuthLayout.vue?vue&type=template&id=2b8f15b8&"
import script from "./TheAuthLayout.vue?vue&type=script&lang=js&"
export * from "./TheAuthLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports